import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import actions from "./actions";
// Modules
import apiKeys from "./api-keys";
import auth from "./auth";
import banners from "./banners";
import blogs from "./blogs";
import brands from "./brands";
import carts from "./carts";
import cashOutput from "./cash-outputs";
import collections from "./collections";
import commons from "./commons";
import control from "./control";
import customLinks from "./custom-links";
import customers from "./customers";
import files from "./files";
import getters from "./getters";
import images from "./images";
import inventories from "./inventories";
import legal from "./legal";
import lines from "./lines";
import logisticConfigurations from "./logistic-configurations";
import merchants from "./merchants";
import mutations from "./mutations";
import notifications from "./notifications";
import onboarding from "./onboarding";
import orders from "./orders";
import platformSubscriptions from "./platform-subscriptions";
import products from "./products";
import roles from "./roles";
import state from "./state";
import stores from "./stores";
import suppliers from "./suppliers";
import supplyLists from "./supply-lists";
import tenants from "./tenants";
import users from "./users";
import warehouses from "./warehouses";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ["auth", "control", "commons", "stores"]
});

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        apiKeys,
        logisticConfigurations,
        notifications,
        onboarding,
        inventories,
        supplyLists,
        warehouses,
        collections,
        cashOutput,
        customLinks,
        merchants,
        suppliers,
        customers,
        products,
        commons,
        control,
        banners,
        images,
        brands,
        orders,
        platformSubscriptions,
        files,
        blogs,
        tenants,
        stores,
        users,
        lines,
        legal,
        roles,
        carts,
        auth
    },
    strict: false,
    plugins: [vuexLocal.plugin]
});
